import { styled, Button } from '@mui/material';

export const BackToPublicBtn = styled(Button)`
    height: 40px;
    background: #c9f5dc;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 700;
    color: #1ea557;
    &:hover {
        background: #c9f5dc;
    }
`;
